import { Box, Typography } from "@material-ui/core";
import { CreateButton, TopToolbar } from "react-admin";
import AddIcon from '@mui/icons-material/Add';

const CustomActions = ({title, addBtnLabel, type='list' | 'edit' | 'create'}) => (
  <TopToolbar
    sx={{
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
    }}
  >
    <Box>
      <Typography
        variant="h4"
        component='h1'
      >
        {title}
      </Typography>
    </Box>
    {type === 'list' && (
      <CreateButton
        label={addBtnLabel}
        startIcon={<AddIcon />}
        sx={{
          textTransform: 'none',
          backgroundColor: 'primary.main',
          color: 'white',
          '&:hover': {
            backgroundColor: 'primary.dark',
          },
          padding: '8px 14px'
        }}
      />
    )}
  </TopToolbar>
);

export default CustomActions;
export { CustomActions };